import React from 'react';
import {
    Alert,
    Chip,
    Stack,
    Typography,
} from '@mui/material';
import SimilarityGraph from './SimilarityGraph';
import SimilarityRelationList from './SimilarityRelationList';
import {useSession} from '../../../firebase/UserProvider';

function subjectListLabel(subjectType) {
    if (subjectType === 'GAP') return 'Gap';
    return 'EEI';
}

/**
 * EEI / Gap Similarity tab: graph + subject-level relation lists
 * (aligned with IcrSimilaritySection). Heading follows payload subjectType.
 */
export default function EeiSimilaritySection({similarity}) {
    const {
        data,
        loading,
        error,
        running,
    } = similarity;
    const {user} = useSession();
    const subjectType = data?.subjectType || 'EEI';

    return (
        <Stack spacing={1.5}>
            {(running || data?.job?.status === 'failed') && (
                <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                    {running && (
                        <Chip label="Recomputing…" size="small" color="info" variant="outlined"/>
                    )}
                    {data?.job?.status === 'failed' && (
                        <Chip label="Last run failed" size="small" color="error" variant="outlined"/>
                    )}
                </Stack>
            )}

            {running && (
                <Alert severity="info" variant="outlined">
                    Similarity recomputing in background…
                </Alert>
            )}
            {error && (
                <Alert severity="warning" variant="outlined">{error}</Alert>
            )}
            {loading && !data && (
                <Typography variant="body2" color="text.secondary">Loading similarity…</Typography>
            )}

            {data && (
                <>
                    <SimilarityGraph payload={data} onEdgeReviewed={similarity?.reload}/>
                    <Typography variant="subtitle2" fontWeight={700}>
                        {`Similar to this ${subjectListLabel(subjectType)}`}
                    </Typography>
                    <SimilarityRelationList
                        edges={data.edges}
                        byRelation={data.byRelation}
                        onEdgeReviewed={similarity?.reload}
                        currentUserId={user?.uid}
                        subject={{type: subjectType, id: data.subjectId}}
                        showAddRelation
                    />
                </>
            )}
        </Stack>
    );
}
